import { COMPANY } from '../../config/company';
import { LegalLayout } from './LegalLayout';

export function RefundPolicyPage() {
  return (
    <LegalLayout
      path="/refund-policy"
      title="Refund Policy"
      intro="When you pay through Hethera but the service is not delivered, you get your money back."
    >
      <h2>Charged but not delivered</h2>
      <p>
        If your card is charged and the provider does not deliver your airtime, data, cable
        subscription or electricity token, we refund your card automatically and tell you in the chat.
        You do not need to ask. The refund is the full amount charged, including any service fee or card processing fee. How
        long the money takes to arrive depends on your bank.
      </p>

      <h2>When the outcome is unclear</h2>
      <p>
        Sometimes the bank or the provider does not give a clear answer straight away. When that
        happens we keep checking automatically, every few minutes at first, until we know whether
        the purchase went through. If it did, you get your purchase. If it didn't, we refund your card.
        If your card charge is only confirmed late, we refund it rather than make the purchase late.
        We tell you in the chat either way.
      </p>

      <h2>Declined cards are never retried</h2>
      <p>
        If your bank declines a payment, Hethera never charges the card again on its own. A new
        attempt only happens when you ask for the purchase again and confirm it with your PIN.
      </p>

      <h2>Ejor payments</h2>
      <p>
        When someone pays a bill for you with Ejor, the payment is made with their card. If that
        purchase is not delivered, the refund goes back to the card of the person who paid.
      </p>

      <h2>Card verification charge</h2>
      <p>The small charge made when you add a card is refunded.</p>

      <h2>Delivered purchases</h2>
      <p>
        Purchases delivered to the number you confirmed, such as airtime, data or a token, cannot be
        reversed. Please check recipient details before you enter your PIN.
      </p>

      <h2>Something not right?</h2>
      <p>
        Email <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a> with the
        transaction reference from your receipt. We will investigate and reply within the support hours
        listed below.
      </p>
      <p>Support hours: {COMPANY.supportHours}.</p>
    </LegalLayout>
  );
}
